












import { Vue, Component, Prop } from "vue-property-decorator";

/**
 * This component contains global styles for the ANX application
 * Every content has to be inside this component
 */
@Component({})
export default class AnxGlobal extends Vue {
  /**
   * By default, the component has a height of 100vh to cover the whole screen.
   * By setting this propoerty, this behaviour can be suppressed.
   */
  @Prop({ default: null }) disableFullscreen!: boolean | null;
}
